export default __webpack_public_path__ + "static/media/mmaBetclub.0958bb36.jpg";